export const AUTH_START = "AUTH_START";
export const AUTH_SUCCESS = "AUTH_SUCCESS";
export const AUTH_FAIL = "AUTH_FAIL";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const SEND_PRODUCT_APPROVAL = "SEND_PRODUCT_APPROVAL";
export const SEND_APPROVAL_START = "SEND_APPROVAL_START";
export const GET_LANGUAGE_ID = "GET_LANGUAGE_ID";
export const GET_LANGUAGE_LIST = "GET_LANGUAGE_LIST";
export const GET_TOKEN = "GET_TOKEN";
export const GET_CART_COUNTER = "GET_CART_COUNTER";
export const GET_WISHLIST_COUNTER = "GET_WISHLIST_COUNTER";
export const GET_BUYINGWINDOW_COUNTER = "GET_BUYINGWINDOW_COUNTER";
export const SET_SUB_HEADING = "SET_SUB_HEADING";
export const  GET_INITIATE_ASSESSMENT_CLICK = "GET_INITIATE_ASSESSMENT_CLICK";
export const QUESTION_WITH_QUERY = 'QUESTION_WITH_QUERY';
export const ISOPEN = 'ISOPEN';
export const ISCLOSE = 'ISCLOSE';
export const QUESTION_WITH_QUERY_COUNT = 'QUESTION_WITH_QUERY_COUNT';
export const QUESTION_WITH_QUERY_IFRAME = 'QUESTION_WITH_QUERY_IFRAME';
export const QUESTION_WITH_QUERY_TITLE = 'QUESTION_WITH_QUERY_TITLE';
export const VIEW_RECOMMENDATIONS_BUTTON_OPEN = 'VIEW_RECOMMENDATIONS_BUTTON_OPEN';
export const VIEW_RECOMMENDATIONS_BUTTON_CLOSE = 'VIEW_RECOMMENDATIONS_BUTTON_CLOSE';
export const VIEW_RECOMMENDATIONS_BUTTON_URL = 'VIEW_RECOMMENDATIONS_BUTTON_URL';
export const QUESTION_WITH_QUERY_SHOW = 'QUESTION_WITH_QUERY_SHOW';
export const QUESTION_WITH_QUERY_QwcLoader = 'QUESTION_WITH_QUERY_QwcLoader';
export const QUESTION_WITH_QUERY_QwcOpen = 'QUESTION_WITH_QUERY_QwcOpen';
export const QUESTION_WITH_QUERY_Comments = 'QUESTION_WITH_QUERY_Comments';
export const REFRESH_IFRAME = 'REFRESH_IFRAME';
export const UPLOAD_ACTIVITY_CODE = 'UPLOAD_ACTIVITY_CODE';
export const SET_CHAT_WITH_SNOWKAP_AI_STATUS = 'SET_CHAT_WITH_SNOWKAP_AI_STATUS';